import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LOCAL_STORAGE } from '../Guards/localstorage.service';
import { ApiResponse } from '../_models/apiresponse';
import { User } from '../_models/User';
import { UserModel } from '../_models/UserModel';
import { LoginServiceService } from './api/login-service.service';
import { CommonService } from './common.service';
//import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable()


export class AuthService {
  //storageSub= new BehaviorSubject(false);
   storageSub= new Subject<String>();
   selectedAccountId = new BehaviorSubject(undefined);
  private loggedIn$ = new BehaviorSubject<boolean>(this.hasToken());
  enableManagedLTL = new BehaviorSubject(false);

  enableBatch = new BehaviorSubject(false);
  enableBoxTypes = new BehaviorSubject(false);
  currentBoxTypeList = new BehaviorSubject([]);
  isUserLoggedIn = new BehaviorSubject(false);
  chosenMerchantId = new BehaviorSubject(null);
  chosenProfileId = new BehaviorSubject(undefined);
  currentProfile = new BehaviorSubject({});
  currentClient = new BehaviorSubject({});
  currentMerchant = new BehaviorSubject({});
 // isSystemAdmin = new BehaviorSubject<boolean>(this.getIsSystemAdmin());
  totalMerchantList = new BehaviorSubject([]);
  totalProfileList = new BehaviorSubject([]);
  private currentUser$ = new BehaviorSubject<UserModel>(this.getCurrentUser());
  userInfo$ = new BehaviorSubject<any>(null);
  headers: any = {};
  httpClient: HttpClient;
  user : User | undefined;
  clientAPI: string;

  constructor(private router: Router,
              private http: HttpClient,
              @Inject(LOCAL_STORAGE) private localStorage: Storage,
              private jwtHelper: JwtHelperService,
              handler: HttpBackend,private common: CommonService) {
    this.httpClient = new HttpClient(handler);
  }
  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn$.asObservable();
  }

  get currentUser(): UserModel {
    return this.currentUser$.value;
  }

  getIPAddress(): Observable<string> {
    return this.httpClient.get<string>('https://jsonip.com');
  }

  // login(payload: { username: any; password: any; }) {
  //   return this.http.post(environment.apiUrl + environment.apiVersion + environment.apiEndPoint.AuthenticationService+"/?username="+payload.username+"&password="+payload.password+ 'Authenticate', payload)
  // }

  loginAuthenticate(userDetails): Observable<any> {

    // this.localStorage.removeItem('token');
    // this.localStorage.removeItem('refreshToken');
    // this.localStorage.removeItem('authData');
    // this.localStorage.removeItem('currentUser');
    // this.localStorage.removeItem('isAuthenticated');
    this.localStorage.clear();

    var user = {
      UserName : userDetails.username,
      Password : userDetails.password,
      RememberMe: true
    }

    return this.http
      .post<ApiResponse<UserModel>>(this.common.getApiAddress() + "/Account/Login", user)
      .pipe(
        map((loginResponse: any) => {
          if (loginResponse && loginResponse.authData) {

            this.localStorage.setItem('authData', JSON.stringify(loginResponse.authData));

            this.localStorage.setItem('role', loginResponse.role!);
            this.localStorage.setItem('userName', loginResponse.userName!);
            this.localStorage.setItem('id', loginResponse.id!);
            this.localStorage.setItem('clientid', loginResponse.ClientKey!);


            if(loginResponse.authData.token != undefined)
            {
              this.localStorage.setItem('token', loginResponse.authData.token!);
              this.localStorage.setItem('refreshToken', loginResponse.authData.refreshToken!);
              this.localStorage.setItem('isAuthenticated', JSON.stringify(true));

            }

            this.loggedIn$.next(true);

            this.currentUser$.next(loginResponse);

            this.getIPAddress().subscribe((data: any) => {
              loginResponse.ipAddress = data.ip;
              this.localStorage.setItem('currentUser', JSON.stringify(loginResponse));
            });

            return {
              loggedIn: true,
              IsFirstTimeLogin : loginResponse.idfirsttimelogin,
              token : loginResponse.token,
              username : loginResponse.userName,
              Role : loginResponse.role
            };
          } else {
            this.loggedIn$.next(false);
            return {loggedIn: false, message: loginResponse ? loginResponse.message : undefined};
          }
        })

      );
  }

  // getRole(): Observable<string> {
  //   this.localStorage.removeItem('role');
  //   return this.http.get<ApiResponse<any>>(`AuthorizationService/v1/api/Contact/Role`).pipe(
  //     map((roleResponse: ApiResponse<any>) => {
  //       if (roleResponse && roleResponse.response.role.Name) {
  //         this.localStorage.setItem('role', roleResponse.response.role.Name);
  //         return roleResponse.response.role.Name;
  //       }
  //       return '';
  //     })
  //   );
  // }

  logout() {
    this.localStorage.clear();
    // this.localStorage.removeItem('token');
    // this.localStorage.removeItem('refreshToken');
    // this.localStorage.removeItem('currentUser');
    // this.localStorage.removeItem('role');
    // this.localStorage.removeItem('isAuthenticated');
    this.loggedIn$.next(false);
    this.currentUser$.next(new UserModel);
    this.router.navigate(['/login']);
  }

  authorizeRequest(data: any): Observable<boolean> {
    const authParameters = new HttpParams().set('resource', data.resource).set('accessPoint', data.accessPoint);
    return this.http.get<any>('AuthorizationService/v1/api/Authorize', { params: authParameters }).pipe(
      map((authResponse: any) => {
        if (authResponse && authResponse.response.IsAuthorize) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  changePassword(data: any): Observable<any> {
    return this.http.put<any>('AuthenticationService/v1/api/Authenticate/Password', data);
  }

  public forgotPassword(data: any): Observable<any> {
    const headers = new HttpHeaders({
      activityBy: 'Surya',
      activityFrom: 'Shipstore Web'
    });
    return this.http.post<any>('AuthenticationService/v1/api/User/Password/Forget', data, { headers });
  }

  public resetPassword(data: any): Observable<any> {
    const headers = new HttpHeaders({
      activityBy: 'Surya',
      activityFrom: 'Shipstore Web'
    });
    return this.http.post<any>('AuthenticationService/v1/api/User/Password/Reset', data, { headers });
  }

  private hasToken(): boolean {
    return !!this.localStorage.getItem('token');
  }

  // private getIsSystemAdmin(): boolean {
  //   return !!(this.localStorage.getItem('role') === environment.systemAdminRoleName);
  // }

  public getToken(): string {
    return this.localStorage.getItem('token')!;
  }

  public getCurrentUser(): UserModel {
    const currentUserFromStorage = this.localStorage.getItem('currentUser');
    if (currentUserFromStorage) {
      return JSON.parse(currentUserFromStorage) as UserModel;
    }
    return new UserModel();
  }



  // getPerson(userName:string): Observable<any>{
  //    return this.http.get(environment.apiUrl + environment.apiVersion + environment.apiEndPoint.GetPerson,{
  //     params: new HttpParams().set('id',userName)
  //    })
  // }

  isTokenValid() {
    const token: string | null = localStorage.getItem("token");
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      return true;
    }
    else {
      return false;
    }
  }

  // async isUserAuthenticated() {
  //   const token = localStorage.getItem("token");
  //   console.log(token);

  //   if (token && !this.jwtHelper.isTokenExpired(token)) {
  //     console.log(this.jwtHelper.decodeToken(token));
  //     return true;
  //   }

  //   const isRefreshSuccess = await this.tryRefreshingTokens(token!);
  //   if (!isRefreshSuccess) {
  //     this.router.navigate(["login"]);
  //   }

  //   return isRefreshSuccess;
  // }

  // public async tryRefreshingTokens(token: string): Promise<boolean> {
  //   // Try refreshing tokens using refresh token
  //   const refreshToken: string|null = localStorage.getItem("refreshToken");
  //   console.log('In Refresh Token Method');
  //   console.log(refreshToken);
  //   if (!token || !refreshToken) {
  //     return false;
  //   }

  //   var currentUserName = this.getCurrentUser().userName;

  //   const credentials = JSON.stringify({ accessToken: token, refreshToken: refreshToken, userName: currentUserName });
  //   let isRefreshSuccess: boolean;
  //   try {
  //     const response = await this.http.post(environment.apiUrl + environment.apiVersion + environment.apiEndPoint.TokenRefreshService, credentials, {
  //       headers: new HttpHeaders({
  //         "Content-Type": "application/json"
  //       }),
  //       observe: 'response'
  //     }).toPromise();

  //     // If token refresh is successful, set new tokens in local storage.
  //     const newToken = (<any>response).body.accessToken;
  //     const newRefreshToken = (<any>response).body.refreshToken;

  //     console.log(newToken);
  //     console.log(newRefreshToken);

  //     localStorage.setItem("token", newToken);
  //     localStorage.setItem("refreshToken", newRefreshToken);
  //     isRefreshSuccess = true;
  //   }
  //   catch (ex) {
  //     isRefreshSuccess = false;
  //   }
  //   return isRefreshSuccess;
  // }
}

// export class AuthService {
//   private currentUserSubject: BehaviorSubject<User>;
//   public currentUser: Observable<User>;

//   constructor(private http: HttpClient,private common: CommonService) {
//       // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
//       this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')!));
//       this.currentUser = this.currentUserSubject.asObservable();
//   }

//   public get currentUserValue(): User {
//       return this.currentUserSubject.value;
//   }

//   // login(username: string, password: string) {
//   //     return
//   //     // this.http.post<any>(`${this.common.getApiAddress().Test}/users/authenticate`, { username, password })
//   //     this.http.post<any>(`${environment.apiUrl + environment.apiVersion + environment.apiEndPoint.AuthenticationService}/Authenticate`, { username, password })
//   //         .pipe(map(user => {
//   //             // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
//   //             user.authdata = window.btoa(username + ':' + password);
//   //             localStorage.setItem('currentUser', JSON.stringify(user));
//   //             this.currentUserSubject.next(user);
//   //             return user;
//   //         }));
//   // }

//   login(userDetails): Observable<any> {
//     userDetails.RememberMe = true;
//     return this.http.post<any>(this.common.getApiAddress() + "/Account",userDetails)
//     .pipe(
//       map<any, any>(r => {
//         localStorage.setItem("Islogin","true");
//         r.authdata = window.btoa(userDetails.username + ':' + userDetails.password);
//         localStorage.setItem('currentUser', JSON.stringify(r));
//         this.currentUserSubject.next(r);
//         return r;

//         }),
//         catchError(e => {
//           localStorage.setItem("Islogin","false");
//           return this.common.handleError("Login failed", e);
//         })
//       );
//   }

//   logout() {
//       // remove user from local storage to log user out
//       localStorage.removeItem('currentUser');
//       // this.currentUserSubject.next(null);
//       this.currentUserSubject.next(new User());
//   }
// }
// export class AuthService {
//   // constructor(public jwtHelper: JwtHelperService) {}
//   // // ...
//   // public isAuthenticated(): boolean {
//   //   const token = localStorage.getItem('token');
//   //   // Check whether the token is expired and return
//   //   // true or false
//   //   return !this.jwtHelper.isTokenExpired(token);
//   // }
//   private currentUserSubject: BehaviorSubject<User>;
//   public currentUser: Observable<User>;
//   constructor(private _LoginService : LoginServiceService,private http: HttpClient) {
//     // this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
//     this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')!));
//     this.currentUser = this.currentUserSubject.asObservable();

//   }
// logout() {
//     // remove user from local storage to log user out
//     localStorage.removeItem('currentUser');
//     // this.currentUserSubject.next(null);
//     this.currentUserSubject.next(new User());
// }
//   // ...
//   public isAuthenticated(): boolean {
//   var IsLogin = localStorage.getItem("Islogin");
//    switch(IsLogin){
//     case "true": return true;
//     case "false": case "no": case "0": case null: return false;
//     default: return Boolean(IsLogin);
// }
//   }
// }
